module.exports = __webpack_public_path__ + "static/media/resposabilidad.a5cc178f.jpg";